var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 885,
    height: 354,
    viewBox: "0 0 885 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115 352.5C76.5999 355.7 61.3332 349.167 58.4999 345.5C47.2999 340.782 43.8332 327.534 43.4999 321.5C30.6665 235.667 4.19989 58.3 0.999886 35.5C-2.20011 12.7 23.9999 2.33333 37.4999 0C298 11.5 827.1 36.2 859.5 43C888.3 51.8 886.833 69.6667 882.5 77.5C868.667 143.667 840.2 279.6 837 294C833.8 308.4 812.667 316.667 802.5 319L530 333C407.667 338.833 153.4 350.9 115 352.5Z",
    fill: "url(#paint0_linear_823_6055)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_823_6055",
    x1: 442.81,
    y1: 0,
    x2: 442.81,
    y2: 353.357,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ED593B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F69127"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector 1.c1c614f64401a35a26f3c7c4f3ca235d.svg";
export { ForwardRef as ReactComponent };